import { apiGeeDomain, contentDomain, API_CONST } from '../config/connections'

export const getAEMServiceURL = ({ service, locale }) => {
  const serviceEndpoint = API_CONST.aem[service]
  const updateLocale =
    serviceEndpoint && serviceEndpoint.replace('{locale}', locale)

  return `${contentDomain}${updateLocale}`
}

export const getGraphQLServiceURL = ({ service }) =>
  `${apiGeeDomain}${API_CONST.graphql[service]}`

export const getGraphQLAPIErrorCode = (apiResponse) =>
  apiResponse?.graphQLErrors[0]?.extensions?.errorCode || null

export const getGraphQLAPIErrorPayeeList = (apiResponse) =>
  apiResponse?.graphQLErrors[0]?.extensions?.data?.payeeList || null

export const getGraphQLAPIErrors = ({
  graphQLErrors,
  networkError,
  setErrorObj
}) => {
  if (graphQLErrors) {
    setErrorObj(graphQLErrors)
  } else if (networkError) {
    setErrorObj(networkError)
  }
  return null
}
